export default "__VITE_ASSET__ChPWOY7o__"